export enum AutomationStageType {
  None = 'None',
  AutomationTypes = 'Automation Types Selector',
  QuickAiForm = 'Quick AI Form',
  GuidedAiForm = 'Guided AI Form',
  GuidedAiReview = 'Guided AI Sample Review',
  GuidedAiStatus = 'Show Guided AI Status',
  ViewStatus = 'View Model Status',
}
